import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse} from '../../../../shared/models/ApiModels'
import {ICalendarEventRequest, ICalendarOccurrence} from './CalendarModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const CALENDAR_URL = `${API_URL}api/v1/calendar/`
const GOOGLE_URL = `${API_URL}api/v1/google/`

/** Görünen aralıktaki tekrarlar; from ve to dahil (YYYY-MM-DD) */
export function loadOccurrences(
  from: string,
  to: string
): Promise<AxiosResponse<ApiResponse<ICalendarOccurrence[]>>> {
  return corporateApi.get(`${CALENDAR_URL}occurrences`, {params: {from, to}})
}

export function createCalendarEvent(request: ICalendarEventRequest) {
  return corporateApi.post(`${CALENDAR_URL}create`, request)
}

/** Serinin tamamını günceller */
export function updateCalendarEvent(id: string, request: ICalendarEventRequest) {
  return corporateApi.patch(`${CALENDAR_URL}update/${id}`, request)
}

/** occurrenceDate verilirse yalnızca o tekrar, verilmezse serinin tamamı silinir */
export function deleteCalendarEvent(id: string, occurrenceDate?: string) {
  return corporateApi.delete(`${CALENDAR_URL}delete/${id}`, {params: occurrenceDate ? {occurrenceDate} : {}})
}

export function setTaskCompleted(id: string, occurrenceDate: string, completed: boolean) {
  return corporateApi.post(`${CALENDAR_URL}${id}/completed`, null, {params: {occurrenceDate, completed}})
}

export interface IGoogleStatus {
  /** Sunucuda Google entegrasyonu ayarlı mı */
  configured: boolean
  connected: boolean
  googleEmail?: string | null
}

export function getGoogleStatus(): Promise<AxiosResponse<ApiResponse<IGoogleStatus>>> {
  return corporateApi.get(`${GOOGLE_URL}status`)
}

export function getGoogleAuthUrl(): Promise<AxiosResponse<ApiResponse<string>>> {
  return corporateApi.get(`${GOOGLE_URL}auth-url`)
}

export function connectGoogle(code: string, state: string): Promise<AxiosResponse<ApiResponse<IGoogleStatus>>> {
  return corporateApi.post(`${GOOGLE_URL}connect`, {code, state})
}

export function disconnectGoogle() {
  return corporateApi.delete(`${GOOGLE_URL}disconnect`)
}
